module.exports = "<main-menu ng-if=\"$ctrl.showMenu()\" ng-class=\"$ctrl.getCssMenu()\" links=\"$ctrl.links\"></main-menu>\n\n<main-menu-mobile ng-if=\"$ctrl.showMenuMobile()\" links=\"$ctrl.links\" employee-info=\"$ctrl.employee\" show-links=\"$ctrl.showMobileLinks()\"></main-menu-mobile>\n\n<div ng-if=\"$ctrl.isLoaded\" ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/features/loansRouting/loansRouting.html
// module id = 1764
// module chunks = 0